import { render, staticRenderFns } from "./EditSourceProxyForm.vue?vue&type=template&id=368320c2&"
import script from "./EditSourceProxyForm.vue?vue&type=script&lang=js&"
export * from "./EditSourceProxyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports